<template>
  <div class="im-sidebar__customer">
    <img
      class="default"
      @click="handleClickSmartCustomer"
      :src="`${staticBaseUrl}assets/af590d00/c9c7852e/customerservice.svg`"
    />
    <img
      class="hover"
      @click="handleClickSmartCustomer"
      :src="`${staticBaseUrl}assets/af590d00/c9c7852e/customerservice_active.svg`"
    />
    <div class="message__unread" @click="handleClickSmartCustomer">
      <p>{{ $t('pc_IM_text_smart_customer') }}</p>
    </div>
    <yxtbiz-aibox
      v-if="aiboxVisible"
      ref="aiboxref"
      @close="handleClose"
      @staffService="changeStaff"
    >
    <template v-slot:quick-link>
      <div class="ai-box-btn" @click="goHelpCenter">
        <yxt-svg
        :remote-url="`${staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`"
        :width="16"
        :height="16"
        icon-class="ai_instruct"
      />
        <span class="ml4">{{$t('pc_biz_ai_help_center').d('帮助中心')}}</span>
      </div>
      <div class="ml8">
        <yxtbiz-platform-contacts></yxtbiz-platform-contacts>
      </div>
    </template>
  </yxtbiz-aibox>
    <div></div>
  </div>
</template>

<script>
import { staticBaseUrl } from '@/conost/index'
import { getOrgInfo } from '@IM/service/main.service'
const zhichiScriptName = 'zhichiScript'
export default {
  data() {
    return {
      staticBaseUrl,
      aiboxVisible: false
    }
  },
  components: {},
  props: {
    // 是否开启aibox客服
    isOpenAiBox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    serviceType() {
      return this.aiboxVisible ? '2' : ''
    }
  },
  mounted() {
    this.loadSmartCustomer()
  },
  unmounted() {
    this.unloadSmartCustomer()
  },
  methods: {
    goHelpCenter() {
      window.open(`${window.location.origin}/support/#/center`, '_blank');
    },
    unloadSmartCustomer() {
      const script = document.getElementById(zhichiScriptName)
      const parent = script && script.parentNode

      if (parent) {
        parent.removeChild(script)
      }
    },
    loadSmartCustomer() {
      const serviceType = this.serviceType
      this.unloadSmartCustomer()
      let operateLevel = window.localStorage.getItem('operateLevel') || '' // 客户档案运营分级(CSM),S/A/B/C
      let batchId = window.localStorage.getItem('batchId') || '' // 批次id,v5.1~v5.2期间临时使用: 取值参考: a001,a002
      function init(operateLevel, batchId) {
        // 智齿客服
        ;(function (w, d, e) {
          w[e] = function () {
            w.cbk = w.cbk || []
            w.cbk.push(arguments)
          }
          const x = d.createElement('script')
          x.async = true
          x.id = 'zhichiScript'
          x.className = 'openZhiChi' + serviceType // 该class绑定到自定义按钮上 第一步
          x.src =
            'https://ten.sobot.com/chat/frame/v2/entrance.js?sysnum=511c0a484f704e5591b7338d069b3bc5&channelid=2'
          d.body.appendChild(x)
        })(window, document, 'zc')
        // eslint-disable-next-line no-undef
        zc('config', {
          uname: window.localStorage.getItem('fullname') || '帮助中心',
          realname: window.localStorage.getItem('username') || 'admin',
          remark: '帮助中心', // 自定义备注
          source: 0,
          title_flag: 2,
          custom_title: '帮助中心客服平台',
          custom: true,
          partnerid: window.localStorage.getItem('userId') || '',
          params: JSON.stringify({
            level: operateLevel, // 客户档案运营分级(CSM),S/A/B/C
            p: batchId, // 批次id,v5.1~v5.2期间临时使用: 取值参考: a001,a002
            orgid: window.localStorage.getItem('orgId') || ''
          })
        })
      }
      if (!operateLevel && !batchId) {
        getOrgInfo(localStorage.getItem('orgId'))
          .then((res) => {
            if (res.operateLevel)
              localStorage.setItem('operateLevel', res.operateLevel)
            if (res.batchId) localStorage.setItem('batchId', res.batchId)
            init(res.operateLevel, res.batchId)
          })
          .catch(() => {
            init(operateLevel, batchId)
          })
      } else {
        init(operateLevel, batchId)
      }
    },
    handleClickSmartCustomer() {
      // if (this.isOpenAiBox) {
      this.aiboxVisible = true
      this.$emit('changeIndex', 1000)
      // }
    },
    handleClose() {
      this.$emit('changeIndex', 899)
      this.aiboxVisible = false
    },
    // 切换为人工客服
    changeStaff(topicId) {
      this.handleClose()
      window.zc('config', {
        type: 2,
        params: JSON.stringify({
          topicId,
          userId: localStorage.getItem('userId'),
          orgId: localStorage.getItem('orgId')
        })
      })
      window.zc('frame_status')
    }
  }
}
</script>

<style scoped lang="scss">
.ai-box-btn {
  padding: 0 12px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #fff;
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
</style>